var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.$t('describe_in_summary')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }